import {Component, computed, effect, inject, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MultiSelect} from 'primeng/multiselect';
import {Checkbox} from 'primeng/checkbox';
import {TranslocoPipe} from '@jsverse/transloco';
import {rxResource} from '@angular/core/rxjs-interop';
import {from} from 'rxjs';
import {ProjectOfficeResponse} from '@frontend/shared';
import {ProjectOfficesProviderService} from '../../services/project-offices-provider.service';

@Component({
  selector: 'app-office-multi-select',
  imports: [FormsModule, MultiSelect, Checkbox, TranslocoPipe],
  templateUrl: './office-multi-select.component.html',
})
export class OfficeMultiSelectComponent {
  protected readonly selectAllInputId = `office-select-all-${crypto.randomUUID()}`;

  private readonly projectOfficesProviderService = inject(ProjectOfficesProviderService);

  readonly projectId = input.required<number>();
  readonly selectedOffices = input.required<ProjectOfficeResponse[]>();
  readonly isReadOnly = input<boolean>(false);

  readonly selectionChange = output<ProjectOfficeResponse[]>();

  protected readonly officesResource = rxResource({
    params: () => ({projectId: this.projectId()}),
    stream: ({params: request}) =>
      from(this.projectOfficesProviderService.getOffices(request.projectId)),
  });

  protected readonly showSelectAll = computed(
    () => (this.officesResource.value() ?? []).length > 1,
  );

  protected readonly allSelected = computed(() => {
    const offices = this.officesResource.value() ?? [];
    return offices.length > 0 && this.selectedOffices().length === offices.length;
  });

  private hasAutoSelected = false;

  constructor() {
    effect(() => this.preselectSingleOffice());
  }

  onToggleAll(checked: boolean): void {
    const offices = this.officesResource.value() ?? [];
    this.selectionChange.emit(checked ? [...offices] : []);
  }

  private preselectSingleOffice(): void {
    const offices = this.officesResource.value();

    if (!offices || this.hasAutoSelected) {
      return;
    }

    this.hasAutoSelected = true;

    if (offices.length === 1 && this.selectedOffices().length === 0) {
      this.selectionChange.emit([offices[0]]);
    }
  }
}
